import { Utils } from './Utils';
const utility = require('utility');

export const calculation = (id, login_from) => {
    const uuid = Utils.getCookie('uuid'); //"10.10.39.120";
    const putaoid = id ? id.toString() : '';
    const ts = new Date().getTime();
    const key = uuid + putaoid + ts + getKey();
    const sign = utility.md5(key);

    return {
        uuid,
        putaoid,
        sign,
        ts,
        from: login_from ? login_from : 'pc',
        // Utils.getHashQueryString('login_from') ? Utils.getHashQueryString('login_from') : "pc"
    };
};

const getKey = () => {
    // const str = "com.abc.putao.nb";
    const str = 'dl.putaoabc.com';
    return utility.md5(str);
};

export const ParamsStr = function (login_from) {
    const params = calculation(null, login_from);

    return `&uuid=${params.uuid}&putaoid=${params.putaoid}&ts=${params.ts}&sign=${params.sign}&from=${params.from}`;
};

export const getParamsObj = function (login_from) {
    const params = calculation(Utils.getCookie('putaoid'), login_from);
    const token = Utils.getCookie('token');

    return {
        putaoid: params.putaoid,
        token: token,
        uuid: params.uuid,
        ts: params.ts,
        sign: params.sign,
        from: params.from,
    };
};

export const getParamsStr = function (login_from) {
    const params = calculation(Utils.getCookie('putaoid'), login_from);
    const token = encodeURIComponent(Utils.getCookie('token'));

    return `&uuid=${params.uuid}&putaoid=${params.putaoid}&token=${token}&ts=${params.ts}&sign=${params.sign}&from=${params.from}`;
};



// WEBPACK FOOTER //
// ./src/utils/InterfaceCalculation.js